import { useEffect, useState, useRef } from 'react'
import { Modal, Button, Image } from 'antd'
import { CloseOutlined, } from '@ant-design/icons';
import style from './index.module.scss'
import * as apis from '../../api/networkDisk'
import useStore from '../../store/useStore'
import { deepCopy, getImgUrlById } from '../../util';
import ImageOverlays from '../../components/ImageOverlays/index';
import ModelScreen from './modelScreen';

interface State {
    txtStr: any
}
interface Props {
    visible?: any
    onClose?: () => void;
    onRefresh?: () => void;
    onClick?: (i: any) => void;
    saveNode?: (i: any) => void;
    txt?: any;
    isAdd?: any;
    operationType?: any;
    change?: (i: any) => void;


}

const ImgPreview = (props: Props) => {
    const { store, dispatch } = useStore();
    const inputRef = useRef<any>()

    const [state, setState] = useState<State>({
        txtStr: ''
    })
    const [taskInfo, setTaskInfo] = useState<any>();
    const [imgId, setImgId] = useState<any>();

    useEffect(() => {
        console.log('store.memoInfo', store.memoInfo)
        if (store.memoInfo?.data && store.imgPreview) {
            let _ImageTag: any = store.memoInfo?.data?.tagMetas?.filter((i: any) => i.notation === 'ImageTag' || i.notation === 'ImgNotesTag') || []
            if (_ImageTag && _ImageTag.length > 0) {
                let _notation: any = store.memoInfo?.data?.tagMetas?.filter((i: any) => i.notation === _ImageTag[0].notation)

                if (_ImageTag[0].notation === 'ImageTag') {
                    setTaskInfo({ ..._notation[0], title: store.memoInfo.data.content })
                    // form.setFieldsValue({
                    //     title: graph.getSelectedCells()[0].data.label || null,
                    //     imagePath: _notation[0].instance.imagePath || null,
                    // });
                    setImgId(_notation[0].instance.imagePath)
                } else if (_ImageTag[0].notation === 'ImgNotesTag') {
                    if (_notation[0].instance.imagePath != '') {
                        // setImgNotesTagNextStep(false)
                    } else {
                        // setImgNotesTagNextStep(true)
                    }
                    setTaskInfo({ ..._notation[0], title: store.memoInfo.data.content })

                    // form.setFieldsValue({
                    //     title: memoInfo.label || null,
                    //     imagePath: _notation[0].instance.imagePath || null,
                    // });
                    setImgId(_notation[0].instance.imagePath)
                    let _annotation: any = []
                    _notation[0].instance.annotation.map((i: any, index: any) => {
                        _annotation.push({
                            id: index,
                            "x": i.x,
                            "y": i.y,
                            "w": i.w,
                            "h": i.h,
                            isCompile: false,
                            subject: i.description,
                            "description": i.description,
                            isSelect: false,
                            isCheck: false
                        })
                    })
                    dispatch({
                        type: 'SET_IMGNOTESTAG',
                        data: _annotation
                    });
                }
            }
        }
    }, [store.memoInfo, store.imgPreview])

    return (
        <>{store.imgPreview && <Modal
            onCancel={() => {
                // setImgPreview(false)
                dispatch({
                    type: 'SET_IMGPREVIEW',
                    data: false
                });
                dispatch({
                    type: 'SET_SELECTTAGMETA',
                    data: {}
                });
                dispatch({
                    type: 'SET_CNODE',
                    data: null
                });
                dispatch({
                    type: 'SET_MYEDITMEMO',
                    data: { content: "", data: {} }
                });
            }}
            title={<ModelScreen showSelect={false} name={taskInfo?.name} />
            }
            width={store.modelFullScreen ? '100%' : '800px'}
            className='HScreen'
            footer={null}
            open={store.imgPreview}>
            <div data-flex='main:justify cross.center'>
                <div className='mb-20  tc word-break title' >{taskInfo?.title}</div>
            </div>
            {taskInfo?.name === '图片格式' ?
                <div className='pos-r' data-flex='main:center cross:center'>
                    <div className={style.img} style={{ backgroundImage: `url(${getImgUrlById(imgId)})` }}>
                        <div className={`previewImg`}>
                            <Image
                                src={getImgUrlById(imgId)}
                                fallback={imgId}
                            />
                        </div>
                    </div>

                </div> :
                <ImageOverlays type={'preview'} disable imgId={imgId} onChange={(e) => {
                    // setAnnotation(e)
                }} />
            }
            <div className='mb-20' ></div>
        </Modal>}
        </>
    )
}

export default ImgPreview